import calculateRange from 'lib/calculate-range';

const filtersFromQuery = (query) => {
  const { filters, terms, dateFrom, dateTo, filtersData, termsData, ...rest } = query;

  const defaultDates = calculateRange();

  let others = {};
  let filtersDataObj = {};
  let termsDataObj = {};

  if (filters) {
    const splitedFilters = filters.split(',');

    splitedFilters.forEach((filter) => {
      const splitedFilter = filter.split('=');

      if (splitedFilter.length !== 2) return;

      const filterType = decodeURIComponent(splitedFilter[0]);
      const filterValue = decodeURIComponent(splitedFilter[1]);
      const isExclusive = filterValue.startsWith('-');
      const cleanValue = isExclusive ? filterValue.substring(1) : filterValue;

      const value = `${filterType}=${cleanValue}`;

      others = {
        ...others,
        // La chiave deve combaciare con quella generata in handleChangeOtherFilter
        // (`${type}-${value}`), altrimenti il merge con filtersData fallisce e si
        // creano entry senza `value`.
        [JSON.stringify(`${filterType}-${value}`)]: {
          type: filterType,
          value,
          isExclusive,
        },
      };
    });
  }

  let termsParams = {};

  if (terms) {
    const splitedTerms = terms.split(',');

    splitedTerms.forEach((term) => {
      const splitedTerm = term.split('=');

      if (splitedTerm.length !== 2) return;

      const termType = decodeURIComponent(splitedTerm[0]);
      const termValue = decodeURIComponent(splitedTerm[1]);
      const isExclusive = termValue.startsWith('-');
      const cleanValue = isExclusive ? termValue.substring(1) : termValue;

      const value = `${termType}=${cleanValue}`;

      termsParams = {
        ...termsParams,
        // Stessa chiave generata in handleChangeTermFilter (`${type}-${value}`).
        [JSON.stringify(`${termType}-${value}`)]: {
          type: termType,
          value,
          isExclusive,
        },
      };
    });
  }

  if (filtersData) {
    filtersDataObj = JSON.parse(decodeURIComponent(filtersData));
    
    // Merge filtersData (label, color, type) with others (value, isExclusive from filters)
    Object.keys(filtersDataObj).forEach((key) => {
      if (others[key]) {
        // Merge the data from filtersData into the object from filters
        others[key] = {
          ...others[key],
          ...filtersDataObj[key],
        };
      } else if (filtersDataObj[key] && filtersDataObj[key].value) {
        // Only adopt orphan entries that still carry a `value`; entries without
        // it would crash the filters selector (filter.value.split).
        others[key] = filtersDataObj[key];
      }
    });
  }

  if (termsData) {
    termsDataObj = JSON.parse(decodeURIComponent(termsData));
    
    // Merge termsData (label, color, type) with termsParams (value, isExclusive from terms)
    Object.keys(termsDataObj).forEach((key) => {
      if (termsParams[key]) {
        // Merge the data from termsData into the object from terms
        termsParams[key] = {
          ...termsParams[key],
          ...termsDataObj[key],
        };
      } else if (termsDataObj[key] && termsDataObj[key].value) {
        // Only adopt orphan entries that still carry a `value` (see filters above).
        termsParams[key] = termsDataObj[key];
      }
    });
  }

  return {
    ...rest,
    others,
    terms: termsParams,
    dateFrom: dateFrom || defaultDates[0],
    dateTo: dateTo || defaultDates[1],
    filtersData: filtersDataObj,
    termsData: termsDataObj,
  };
};

export default filtersFromQuery;
